import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './initialState';
import { invoicingReducer } from './reducer';
import {
  getAllColumnsAction,
  getIndividualClientColumnAction,
  assignColumnsToClientAction,
  addInvoiceAction,
  getExpensesInvoiceListAction,
  getRevenueInvoiceListAction,
  getOtherEntriesListAction,
  viewInvoiceAction,
  editInvoiceAction,
  deleteInvoiceAction,
  deleteDocumentAction,
  downloadInvoiceAction,
  getDocumentListAction,
  invoiceBulkUploadAction
} from './actions';
import { InvoiceColumnsType, InvoicingTypes } from './invoicingTypes';
import { Success } from '../../assets/images';

export const invoicingSlice = createSlice({
  name: 'invoicing',
  initialState,
  reducers: invoicingReducer,
  extraReducers: {
    [getAllColumnsAction.pending.toString()]: (state: InvoicingTypes) => ({
      ...state,
      fetching: true,
    }),
    [getAllColumnsAction.fulfilled.toString()]: (state: InvoicingTypes, { payload }) => {
      const { result = {}, message, status_code, success } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          success,
          statusCode: status_code
        }
      }

      return {
        ...state,
        fetching: false,
        columnList: result
      }
    },
    [getAllColumnsAction.rejected.toString()]: (state: InvoicingTypes, { errors }) => ({
      ...state,
      fetching: false,
      error: errors,
    }),
    [getIndividualClientColumnAction.pending.toString()]: (state: InvoicingTypes) => ({
      ...state,
      fetching: true
    }),
    [getIndividualClientColumnAction.fulfilled.toString()]: (state: InvoicingTypes, { payload }) => {
      const { result = {}, success, message, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code
        }
      }

      return {
        ...state,
        fetching: false,
        individualColumnList: result
      }
    },
    [getIndividualClientColumnAction.rejected.toString()]: (state: InvoicingTypes, { errors }) => ({
      ...state,
      fetching: false
    }),
    [assignColumnsToClientAction.pending.toString()]: (state: InvoicingTypes) => ({
      ...state,
      fetching: true
    }),
    [assignColumnsToClientAction.fulfilled.toString()]: (state: InvoicingTypes, { payload }) => {
      const { success, message, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          success,
          statusCode: status_code
        }
      }

      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code
      }
    },
    [assignColumnsToClientAction.rejected.toString()]: (state: InvoicingTypes, { error }) => {
      return {
        ...state,
        fetching: false,
        error: error?.message
      }
    },
    [invoiceBulkUploadAction.pending.toString()]: (state: any) => ({
      ...state,
      fetching: true
    }),
    [invoiceBulkUploadAction.fulfilled.toString()]: (state: any, { payload }) => {
      const { success, message, status_code, data = {} } = payload

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success
        }
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        bulkUploadData: data
      }
    },
    [invoiceBulkUploadAction.rejected.toString()]: (state: any, { error }) => ({
      ...state,
      fetching: false,
      error: error?.message
    }),
    [viewInvoiceAction.pending.toString()]: (state: InvoicingTypes) => ({
      ...state,
      fetching: true
    }),
    [viewInvoiceAction.fulfilled.toString()]: (state: InvoicingTypes, { payload }) => {

      const { success, message, status_code, result = {} } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success
        }
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        viewInvoiceData: result
      }
    },
    [viewInvoiceAction.rejected.toString()]: (state: InvoicingTypes, { error }) => ({
      ...state,
      fetching: false,
      error: error?.message
    }),
    [deleteDocumentAction.pending.toString()]: (state: any) => ({
      ...state,
      fetching: true
    }),
    [deleteDocumentAction.fulfilled.toString()]: (state: InvoicingTypes, { payload }) => {
      const { success, message, result, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          error: message,
          statusCode: status_code,
          success
        }
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        message,
        success
      }
    },
    [deleteDocumentAction.rejected.toString()]: (state: InvoicingTypes, { error }) => ({
      ...state,
      fetching: false,
      error: error?.message
    }),
    [deleteInvoiceAction.pending.toString()]: (state: InvoicingTypes) => ({
      ...state,
      fetching: true
    }),
    [deleteInvoiceAction.fulfilled.toString()]: (state: InvoicingTypes, { payload }) => {
      const { success, message, result, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          error: message,
          statusCode: status_code,
          fetching: false,
          success
        }
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code
      }
    },

    [deleteInvoiceAction.rejected.toString()]: (state: InvoicingTypes, { error }) => ({
      ...state,
      fetching: false,
      error: error?.message
    }),

    [downloadInvoiceAction.pending.toString()]: (state: InvoicingTypes) => ({
      ...state,
      fetching: true
    }),
    [downloadInvoiceAction.fulfilled.toString()]: (state: InvoicingTypes, { payload }) => {
      const { success, message, status_code, result = {} } = payload
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
        }
      }
      return {
        ...state,
        fetching: false,
        // result,
        statusCode: status_code,
        success
      }
    },
    [downloadInvoiceAction.rejected.toString()]: (state: InvoicingTypes, { error }) => ({
      ...state,
      fetching: false,
      error: error?.message
    }),
    [editInvoiceAction.pending.toString()]: (state: InvoicingTypes) => ({
      ...state,
      fetching: true
    }),
    [editInvoiceAction.fulfilled.toString()]: (state: InvoicingTypes, { payload }) => {
      const { success, message, status_code, result = {} } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success
        }
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success
      }
    },
    [editInvoiceAction.rejected.toString()]: (state: InvoicingTypes, { error }) => ({
      ...state,
      fetching: false,
      error: error?.message
    }),

    [getDocumentListAction.pending.toString()]: (state: any) => ({
      ...state,
      fetching: true,
    }),
    [getDocumentListAction.fulfilled.toString()]: (state: any, { payload }) => {
      const { success, message, status_code, result = {} } = payload

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success
        }
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        documentList: result
      }

    },
    [getDocumentListAction.rejected.toString()]: (state: any, { error }) => ({
      ...state,
      fetching: false,
      error: error?.message
    }),
    [addInvoiceAction.pending.toString()]: (state: InvoicingTypes) => ({
      ...state,
      fetching: true
    }),

    [addInvoiceAction.fulfilled.toString()]: (state: InvoicingTypes, { payload }) => {
      const { success, message, status_code, result = {} } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success
        }
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success
      }
    },
    [addInvoiceAction.rejected.toString()]: (state: InvoicingTypes, { error }) => ({
      ...state,
      fetching: false,
      error: error?.message
    }),
    [getExpensesInvoiceListAction.pending.toString()]: (state: InvoicingTypes) => ({
      ...state,
      fetching: true
    }),
    [getExpensesInvoiceListAction.fulfilled.toString()]: (state: InvoicingTypes, { payload }) => {
      const { success, message, result, status_code } = payload;
      let count = 0;
      if (result?.data) {
        result?.data?.map((val: any) => {
          if (val?.upload === null) {
            count++;
          }
        })
      }

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code
        }
      }

      return {
        ...state,
        fetching: false,
        expensesInvoiceList: result,
        missingExpensesAttachmentCount: count
      }
    },
    [getExpensesInvoiceListAction.rejected.toString()]: (state: InvoicingTypes, { error }) => ({
      ...state,
      fetching: false,
      error: error?.message
    }),

    [getRevenueInvoiceListAction.pending.toString()]: (state: InvoicingTypes) => ({
      ...state,
      fetching: true
    }),
    [getRevenueInvoiceListAction.fulfilled.toString()]: (state: InvoicingTypes, { payload }) => {
      const { success, message, result, status_code } = payload;
      let count = 0;
      if (result?.data) {
        result?.data?.map((val: any) => {
          if (val?.upload === null) {
            count++;
          }
        })
      }

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code
        }
      }

      return {
        ...state,
        fetching: false,
        revenueInvoiceList: result,
        missingRevenueAttachmentCount: count
      }
    },
    [getOtherEntriesListAction.rejected.toString()]: (state: InvoicingTypes, { error }) => ({
      ...state,
      fetching: false,
      error: error?.message
    }), [getOtherEntriesListAction.pending.toString()]: (state: InvoicingTypes) => ({
      ...state,
      fetching: true
    }),
    [getOtherEntriesListAction.fulfilled.toString()]: (state: InvoicingTypes, { payload }) => {
      const { success, message, result, status_code } = payload;
      let count = 0;
      if (result?.data) {
        result?.data?.map((val: any) => {
          if (val?.upload === null) {
            count++;
          }
        })
      }

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code
        }
      }

      return {
        ...state,
        fetching: false,
        otherEntriesList: result,
        missingOthersAttachmentCount: count
      }
    },
    [getOtherEntriesListAction.rejected.toString()]: (state: InvoicingTypes, { error }) => ({
      ...state,
      fetching: false,
      error: error?.message
    }),
  }
});

export const {
  resetError: resetInvoicingError,
  resetSuccess: resetInvoicingSuccess,
  resetStatusCode: resetInvoiceStatusCode,
  resetInvoicingFetching,
  resetBulkUploadData
} = invoicingSlice.actions;